import React from 'react'
import { AppBasicTable, AppReportSearchesModal } from '@components'
import { useManageHomeStatus, useReportsHomeInfo } from 'Pages/Main/Home/@hooks'
import { Skeleton } from '@mui/material'
import { dateColumn, reportNameColumn } from './columns'
import ReportListTableHomeCustomToolbar from './Toolbar'


export default function ReportsHomeTable() {
	const { data, isLoading } = useReportsHomeInfo()
	useManageHomeStatus()


	if (isLoading) return <Skeleton variant="rectangular" height={470}/>

	return <>
		<AppBasicTable
			title="Last Report Executions"
			toolbarProps={{ actions: false }}
			titleProps={{ actions: false }}
			sx={{ height: 313 }}
			cardProps={{
				headerProps: {
					sx: { pb: .9, height: 120 },
				},
			}}
			data={data.filter(report => report.statusLastExecution && report.enabled)}
			setHeaderCellProps={(_, idx) => ({
				sx: {
					backgroundColor: 'primary.main',
					textAlign: !idx && 'left !important',
				},
			})}
			headers={[[
				{ label: 'Name' },
				{ label: 'Status' },
			]]}
			columns={[
				reportNameColumn(),
				dateColumn(),
			]}
			Components={{
				Title: ({ title }) => <ReportListTableHomeCustomToolbar title={title}/>,
			}}
		/>
		<AppReportSearchesModal data={data}/>
	</>
}